<template>
	<dropdown :disabled="noItems" :label="label">
		<div v-if="showSearch" class="dropdown-item">
			<div class="field">
				<div class="control has-icons-left">
					<input
						v-model="searchText"
						class="input is-small"
						type="search"
						placeholder="Filter"
					/>
					<span class="icon is-left">
						<i class="fas fa-search"></i>
					</span>
				</div>
			</div>
		</div>
		<div v-if="isFiltered" class="dropdown-item">
			<b-checkbox
				:value="!selected.length"
				:class="{ 'show-all-items': !selected.length }"
				@change.native="(e) => clear(e)"
				>All {{ type }}s</b-checkbox
			>
		</div>
		<div v-if="filtered.length > 0">
			<div v-for="item in filtered" :key="item.id" class="dropdown-item">
				<b-checkbox
					v-model="selected"
					:native-value="item.id"
					@input="update"
					>{{ item.title }}</b-checkbox
				>
			</div>
		</div>
		<div v-if="noMatch" class="dropdown-item">
			<p>No match found for your filter</p>
		</div>
	</dropdown>
</template>

<script>
import multiMixin from "../multiMixin";
import Dropdown from "@shared/components/AppDropdown";

import { mapActions, mapGetters } from "vuex";

export default {
	name: "ListingsFilter",
	components: {
		Dropdown
	},
	mixins: [multiMixin],
	data() {
		return {
			type: "listing"
		};
	},
	computed: {
		...mapGetters({
			items: "reportFilters/listings",
			selectedListings: "reportQueries/listings"
		})
	},
	watch: {
		items() {
			this.searchText = "";
		},
		selectedListings(ids) {
			if (!ids.length) {
				this.selected = [];
			}
		}
	},
	beforeDestroy() {
		this.updateListings([]);
	},
	methods: {
		...mapActions({
			updateListings: "reportQueries/updateListings"
		}),
		clear(e) {
			const checked = e.target.checked;
			if (checked) {
				this.selected = [];
			}
			this.updateListings(this.selected);
		},
		update() {
			this.updateListings(this.selected);
		}
	}
};
</script>

<style scoped>
.show-all-items {
	pointer-events: none;
}
.dropdown >>> .dropdown-menu {
	z-index: 3;
	width: 24rem;
	display: none;
}
.dropdown.is-active >>> .dropdown-menu {
	display: block;
}
.dropdown >>> .dropdown-content {
	max-height: 213px;
	overflow-y: auto;
}
</style>
